import React, { memo } from 'react';
import { Button, createUseStyles, Text, Icon, useTheme, Link } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';
const useStyles = createUseStyles(styles, 'TourTooltip');

const TourTooltip = memo(({ step, skipProps, primaryProps, tooltipProps, isLastStep }) => {
    const { t } = useWeb5Context();
    const classes = useStyles();
    const theme = useTheme();

    return (
        <div className={classes.popover} {...tooltipProps}>
            <div className={classes.header}>
                <Text type="subtitle">{step.title}</Text>
                <Icon name="close" color={theme.colors.primary.white} {...skipProps} />
            </div>
            {step.content && <Text type="caption">{step.content}</Text>}
            <div className={classes.bottom}>
                {step.link && (
                    <Link className={classes.link} type="caption" href={step.link} target="_blank">
                        {t('label_learn_more')}
                    </Link>
                )}
                <Button size="small" type="terciary" className={classes.button} {...primaryProps}>
                    {isLastStep && t('action_promotion_got_it')}
                    {!isLastStep && t('action_next')}
                </Button>
            </div>
        </div>
    );
});

export default TourTooltip;
